import { RefObject, useEffect, useRef } from 'react';

interface ImageDirection {
    ref: RefObject<HTMLImageElement>;
    currentIndex: number;
    mediaDataList: { url: string; mimeType: string }[];
    setCurrentIndex: (index: number) => void;
    setCurrentUrl: (url: string) => void;
    setCurrentMimeType: (mimeType: string) => void;
}

interface ImageDirectionResult {
    isLast: boolean;
    isFirst: boolean;
    onClickPrev: () => void;
    onClickNext: () => void;
}

export const useImageDirection = ({
    ref,
    currentIndex,
    mediaDataList,
    setCurrentIndex,
    setCurrentUrl,
    setCurrentMimeType,
}: ImageDirection): ImageDirectionResult => {
    let isLast = false;
    let isFirst = false;

    if (currentIndex === mediaDataList.length - 1) {
        isLast = true;
    }
    if (currentIndex === 0) {
        isFirst = true;
    }

    const onClickNext = () => {
        if (currentIndex === mediaDataList.length - 1) {
            return;
        }
        const newFileIndex = currentIndex + 1;
        setCurrentIndex(newFileIndex);
        setCurrentUrl(mediaDataList[newFileIndex].url);
        setCurrentMimeType?.(mediaDataList[newFileIndex].mimeType);
    };
    const onClickPrev = () => {
        if (currentIndex === 0) {
            return;
        }
        const newFileIndex = currentIndex - 1;
        setCurrentIndex(newFileIndex);
        setCurrentUrl(mediaDataList[newFileIndex].url);
        setCurrentMimeType?.(mediaDataList[newFileIndex].mimeType);
    };

    const currentRef = useRef(ref);

    useEffect(() => {
        const moveDirectionFile = (evt: KeyboardEvent) => {
            const target = evt.target as HTMLElement | null;
            if (target && (target.closest('video') || target.closest('iframe'))) {
                return;
            }
            if (evt.key === 'ArrowLeft') {
                onClickPrev();
            }
            if (evt.key === 'ArrowRight') {
                onClickNext();
            }
        };

        if (currentRef && currentRef.current) {
            window.addEventListener('keydown', moveDirectionFile);
        }

        return () => {
            window.removeEventListener('keydown', moveDirectionFile);
        };
    }, [onClickNext, onClickPrev]);

    return { isLast, isFirst, onClickPrev, onClickNext };
};
